const $cvSections = $(".cv-section")
const $cvVideoBtns = $(".cv-video .cv-video-play-btn")
const $cvVideos = $(".cv-video .cv-video-wrapper video")

export default () => {

	$cvVideoBtns.on("click", (event) => {
		const video = event.target.closest(".cv-video").querySelector(".cv-video-wrapper video") as HTMLVideoElement
		if (video.paused) {
			video.play()
		} else {
			video.pause()
		}
	})

	$cvVideos.on("play", (event) => {
		const cvSection = event.target.closest(".cv-video") as HTMLVideoElement

		if (!cvSection.classList.contains("played")) {
			cvSection.classList.add("played")
		}
		if (!cvSection.classList.contains("playing")) {
			cvSection.classList.add("playing")
		}
	})
	$cvVideos.on("pause", (event) => {
		const cvSection = event.target.closest(".cv-video") as HTMLVideoElement

		if (cvSection.classList.contains("playing")) {
			cvSection.classList.remove("playing")
		}
	})

	$cvVideos.on("ended", (event) => {
		const cvSection = event.target.closest(".cv-video") as HTMLVideoElement

		if (cvSection.classList.contains("played")) {
			cvSection.classList.remove("played")
		}
	})
}